import { render, staticRenderFns } from "./dangerousGoodsList.vue?vue&type=template&id=1aac2728&scoped=true"
import script from "./dangerousGoodsList.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsList.vue?vue&type=script&lang=js"
import style0 from "./dangerousGoodsList.vue?vue&type=style&index=0&id=1aac2728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aac2728",
  null
  
)

export default component.exports